import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaUsers, FaUsersCog } from "react-icons/fa";
import AdminLayout from "../../components/AdminLayout/AdminLayout.js";
import { BiSolidReport } from "react-icons/bi";
import { FaClipboardList } from "react-icons/fa6";

export default function AdminDashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "Admin") {
      // Simplified condition
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    // Listen for back navigation
    const handleBeforeUnload = () => {
      localStorage.clear();
    };

    // Adding event listener for back navigation
    window.addEventListener("popstate", handleBeforeUnload);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener("popstate", handleBeforeUnload);
    };
  }, [navigate]);

  useEffect(() => {
    if (!localStorage.getItem("alertShown")) {
      toast.success("Login successfully");
      localStorage.setItem("alertShown", "true");
    }
  }, []);

  return (
    <AdminLayout ac1="active" ac19="active">
      {/* Content Header (Page header) */}
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h4 className="m-0 text-dark">Dashboard</h4>
            </div>
          </div>
        </div>
      </div>
      <section className="content mb-4">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-sm-6 col-md-4">
              <Link to="/manage-mandal1" className="text-dark">
                <div className="info-box mb-3">
                  <span className="info-box-icon bg-primary elevation-1">
                    <FaUsers />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text pb-1 ">Manage Mandal</span>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <Link to="/manage-group1" className="text-dark">
                <div className="info-box mb-3">
                  <span className="info-box-icon bg-danger elevation-1">
                    <FaUsersCog />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text pb-1 ">Manage Group</span>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <Link to="/sabha-report1" className="text-dark ">
                <div className="info-box mb-3" style={{ cursor: "pointer" }}>
                  <span className="info-box-icon bg-secondary elevation-1">
                    <BiSolidReport />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text pb-1 ">Sabha Report</span>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <Link to="/parasabha-report1" className="text-dark ">
                <div className="info-box mb-3" style={{ cursor: "pointer" }}>
                  <span className="info-box-icon bg-warning elevation-1">
                    <FaClipboardList />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text pb-1 ">Para Sabha Report</span>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </AdminLayout>
  );
}
